import getOr from "lodash/fp/getOr";

export class Statistics {
  constructor(allPartnersValue, allPartnersWorldRank, allPartnersGrowthStartYear, allPartnersGrowthEndYear, allPartnersGrowthRate, bilateralShare, bilateralValue, bilateralGrowthStartYear, bilateralGrowthEndYear, bilateralGrowthRate) {
    this.allPartnersValue = allPartnersValue;
    this.allPartnersWorldRank = allPartnersWorldRank;
    this.allPartnersGrowthStartYear = allPartnersGrowthStartYear;
    this.allPartnersGrowthEndYear = allPartnersGrowthEndYear;
    this.allPartnersGrowthRate = allPartnersGrowthRate;
    this.bilateralShare = bilateralShare;
    this.bilateralValue = bilateralValue;
    this.bilateralGrowthStartYear = bilateralGrowthStartYear;
    this.bilateralGrowthEndYear = bilateralGrowthEndYear;
    this.bilateralGrowthRate = bilateralGrowthRate;
  }
  static fromApiObject(input, hs) {
    if (typeof (input) === "object" && input !== null) {
      const allPartnersValue = getOr("", "data.available.data." + hs + ".ok.allPartners.importValue")(input);
      const allPartnersWorldRank = getOr("", "data.available.data." + hs + ".ok.allPartners.importsWorldRank")(input);
      const allPartnersGrowthStartYear = getOr("", "data.available.data." + hs + ".ok.allPartners.importGrowth.startYear")(input);
      const allPartnersGrowthEndYear = getOr("", "data.available.data." + hs + ".ok.allPartners.importGrowth.endYear")(input);
      const allPartnersGrowthRate = getOr("", "data.available.data." + hs + ".ok.allPartners.importGrowth.rate")(input);
      const bilateralShare = getOr("", "data.available.data." + hs + ".ok.bilateral.importShare")(input);
      const bilateralValue = getOr("", "data.available.data." + hs + ".ok.bilateral.importValue")(input);
      const bilateralGrowthStartYear = getOr("", "data.available.data." + hs + ".ok.bilateral.importGrowth.startYear")(input);
      const bilateralGrowthEndYear = getOr("", "data.available.data." + hs + ".ok.bilateral.importGrowth.endYear")(input);
      const bilateralGrowthRate = getOr("", "data.available.data." + hs + ".ok.bilateral.importGrowth.rate")(input);
      return new Statistics(allPartnersValue, allPartnersWorldRank, allPartnersGrowthStartYear, allPartnersGrowthEndYear, allPartnersGrowthRate, bilateralShare, bilateralValue, bilateralGrowthStartYear, bilateralGrowthEndYear, bilateralGrowthRate);
    }
    return new Statistics();
  }
  static fromApiArray(input, hs) {
    if (Array.isArray(input)) {
      return input.map(item => Statistics.fromApiObject(item, hs));
    }
    if (typeof (input) === "object" && input !== null) {
      return [Statistics.fromApiObject(input, hs)];
    }
    return [];
  }
}